import { defineComponent } from "vue";

import {
  ElConfigProvider,
  ElButton,
  ElForm,
  ElFormItem,
  ElDatePicker,
  ElRadio,
  ElCard,
  ElDivider,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElSubMenu,
  ElEmpty,
  ElColorPicker,
  ElTag,
  ElDropdown,
  ElDropdownItem,
  ElPagination
} from "element-plus";

export default defineComponent({
  components: {
    ElConfigProvider,
    ElButton,
    ElForm,
    ElFormItem,
    ElDatePicker,
    ElRadio,
    ElCard,
    ElDivider,
    ElMenu,
    ElMenuItem,
    ElMenuItemGroup,
    ElSubMenu,
    ElEmpty,
    ElColorPicker,
    ElTag,
    ElDropdown,
    ElDropdownItem,
    ElPagination
  },
  setup() {
    return {
      zIndex: 3000,
      size: "small",
    };
  },
});
